export default function (element, data) {
    const clickEvent = data.clickEvent;
    
    // element.addEventListener("click", function () {
    //     window.dispatchEvent(new Event(clickEvent));
    // });
    element.addEventListener("click", function () {
        const customEvent = new CustomEvent(clickEvent, {
            detail: {
                element,
                dataset: element.dataset
            }
        });

        window.dispatchEvent(customEvent);
    });
}
